import dynamic from 'next/dynamic'

const WatchDynamic = dynamic(
    () => import('@components/display/offer/Watch'),
    { ssr: false },
)

const Watch = (props) => <WatchDynamic {...props} />

export default Watch